module.exports = __webpack_public_path__ + "img/block_5.3936ce5a.png";